<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>내 비방사전 상세 정보</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">기본 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>질병 카테고리</th>
                <td>
                  <span>{{scretPrescriptionInfo.prescribe_category_nm}}</span>
                </td>
                <th>질병 상세 카테고리</th>
                <td><span>{{scretPrescriptionInfo.prescribe_sub_category_nm}}</span></td>
              </tr>
              <tr>
                <th>처방명</th>
                <td>
                  <span>{{scretPrescriptionInfo.prescribe_nm}}</span>
                </td>
                <th>등록자</th>
                <td><span>{{doctor_nm}}</span></td>
              </tr>
              <tr>
                <th>출처</th>
                <td>
                  <span>{{scretPrescriptionInfo.prescribe_source}}</span>
                </td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <th>적응중</th>
                <td colspan="3">
                  <span>{{scretPrescriptionInfo.indications}}</span>
                </td>
              </tr>
              <tr>
                <th>사용 기준</th>
                <td colspan="3">
                  <div class="flex gap8 items-center">
                    <span v-if="scretPrescriptionInfo.usage_criteria_day != ''">{{scretPrescriptionInfo.usage_criteria_day}}일분</span>
                     <span v-if="scretPrescriptionInfo.usage_criteria_dose != ''">{{scretPrescriptionInfo.usage_criteria_dose}}첩</span>
                     <span v-if="scretPrescriptionInfo.usage_criteria_pack != ''">{{scretPrescriptionInfo.usage_criteria_pack}}팩 </span>
                     <span v-if="scretPrescriptionInfo.usage_criteria_unit != ''">{{scretPrescriptionInfo.usage_criteria_unit}}ml</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">환자 증상</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
            <tr>
              <th>성별</th>
              <td><span>{{scretPrescriptionInfo.gender_nm}}</span></td>
              <th>체질과의 연관성</th>
              <td><span>{{scretPrescriptionInfo.constitutionImpact_nm}}</span></td>
            </tr>
            <tr>
              <th>사상체질</th>
              <td><span>{{scretPrescriptionInfo.constitution_nm}}</span></td>
              <th>한열타입</th>
              <td><span>{{scretPrescriptionInfo.thermal_status_nm}}</span></td>
            </tr>
            <tr>
              <th>체력상태</th>
              <td><span>{{scretPrescriptionInfo.physical_condition_nm}}</span></td>
              <th>긴장상태</th>
              <td><span>{{scretPrescriptionInfo.tension_status_nm}}</span></td>
            </tr>
            <tr>
              <th>예민도</th>
              <td><span>{{scretPrescriptionInfo.sensitivity_nm}}</span></td>
              <th>갈증상태</th>
              <td><span>{{scretPrescriptionInfo.thirst_status_nm}}</span></td>
            </tr>
            <tr>
              <th>수면상태</th>
              <td><span>{{scretPrescriptionInfo.sleep_status_nm}}</span></td>
              <th>대변상태</th>
              <td><span>{{scretPrescriptionInfo.bowel_status_nm}}</span></td>
            </tr>
            <tr>
              <th>잔변감</th>
              <td><span>{{scretPrescriptionInfo.residualStoolSense_nm}}</span></td>
              <th>소화상태</th>
              <td><span>{{scretPrescriptionInfo.digestive_status_nm}}</span></td>
            </tr>
            <tr>
              <th>식욕상태</th>
              <td><span>{{scretPrescriptionInfo.appetite_nm}}</span></td>
              <td colspan="2"></td>
            </tr>
            </tbody>
          </table>
        </div>


        <div class="table_list">
          <h3 class="tb_title">처방 약재</h3>
          <table class="list no_view">
            <colgroup>
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
              <col width="12.5%" />
            </colgroup>
            <thead>
              <tr>
                <th>약재명</th>
                <th>이명</th>
                <th>설명</th>
                <th>용량</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in medicineList"
                :key="index"
              >
                <td>
                  <span>{{ item.med_hrb_nm }}</span>
                </td>
                <td>
                  <span>{{ item.med_alias }}</span>
                </td>
                <td>
                  <span>{{ item.med_prfm }}</span>
                </td>
                <td>
                  <span>{{ item.medicine_use_qnty }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">추가 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>비방에 대한 설명 및 가감</th>
                <td colspan="3">
                  <span>{{scretPrescriptionInfo.secret_prescription_adjust}}</span>
                </td>
              </tr>
              <tr>
                <th>참고사항</th>
                <td colspan="3">
                  <span>{{scretPrescriptionInfo.remarks}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table_list">
          <h3 class="tb_title">리뷰</h3>
          <table class="list">
            <colgroup>
              <col width="200" />
              <col width="200" />
              <col width="200" />
              <col width="200" />
              <col width="200" />
              <col width="200" />
            </colgroup>
            <tbody>
              <tr>
                <th>별점</th>
                <th>처방 후 증상</th>
                <th>부작용</th>
                <th>사용방법</th>
                <th>종합평가</th>
                <th>등록자</th>
              </tr>
              <tr v-if="reviewList.length == 0">
                <td colspan="6"><span>데이터가 없습니다.</span></td>
              </tr>
              <tr v-for="(item1, index) in reviewList"
                :key="index"
                @click="fn_open_review_detail(item1)"
              >
                <td @click="fn_open_review_detail(item1)">
                  <StarRating :rating="item1.clinical_rating" />
                </td>
                <td @click="fn_open_review_detail(item1)"><span>{{item1.symptom_change_nm}}</span></td>
                <td @click="fn_open_review_detail(item1)"><span>{{item1.adverse_reaction_nm}}</span></td>
                <td @click="fn_open_review_detail(item1)"><span>{{item1.followup_action_nm}}</span></td>
                <td @click="fn_open_review_detail(item1)">
                  <span class="memo_trigger" @click="fn_open_review_detail(item1)">{{item1.review_content}}</span>
                </td>
                <td @click="fn_open_review_detail(item1)"><span>{{item1.nick_nm}}</span></td>
              </tr>
            </tbody>
          </table>
          <div class="bottom_box bn">
            <button class="btn btn_md btn_darkbrown" @click="fn_move_listPage">
              목록
            </button>
            <button v-if="scretPrescriptionInfo.progress_status == 'RJ'" class="btn btn_md btn_blue" @click="fn_move_listPage">
              재등록
            </button>
          </div>
        </div>
      </article>
    </section>
    <review-detail-modal ref="reviewDetailModal" />
    </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import StarRating from "@/components/common/StarRating.vue";
import ReviewDetailModal from "@/modal/user/reviewDetailModal.vue";

export default {
  components: {
    StarRating,
    ReviewDetailModal
  },
  mixins: [commonUtil],
  data() {
    return {
      secret_prescription_seq : '',
      clinic_doctor_id : '',
      doctor_nm : '',
      scretPrescriptionInfo : {},
      medicineList : [],
      reviewList : []
    };
  },
  created(){
    this.secret_prescription_seq = this.$store.getters['detailSearchInfo/getSearchId']
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
    this.doctor_nm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];

    console.log("@@@@@ secret_prescription_seq :"+this.secret_prescription_seq);
  },
  mounted(){
    this.fn_search();
  },
  methods: {
    fn_search(){

          //환자seq 정보 셋팅
          let param = new Object();
          param.secret_prescription_seq = this.secret_prescription_seq;
          param.clinic_doctor_id = this.clinic_doctor_id;

          //내 비방 정보 상세조회
          axios
              .post("/api/user/hanidata/getMyFormulaLibraryDetail", param)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.scretPrescriptionInfo = res.data.myFormulaLibraryInfo;
                  this.medicineList = res.data.medicineList;
                  this.reviewList = res.data.reviewList;
              })
              .catch((err) => console.log(err));
              
      },
      fn_move_listPage(){
      this.$store.dispatch('detailSearchInfo/setSearchId', '');
      this.$store.dispatch('detailSearchInfo/setStatus', '');
      this.$router.push("/hanidata/myFormulaLibraryList");
    },
    fn_open_review_detail(item){
      this.$refs.reviewDetailModal.open(item);
    },
  }
};
</script>
